import {
    Typography, Paper, Box,
    Divider,
    IconButton,
    Tooltip,
    Stack,
    Button,
  } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { Add, ArrowBack, ArrowForward, Article, Book, Brightness1, ChevronLeft, DarkMode, Download, LightMode, MenuBook, MoreVert, Pageview, Palette, Print, Save, SmartToy } from '@mui/icons-material';
import Page from '../interfaces/page';
import NoteDictionary from '../editor-components/note-dictionary';

interface ResourcesTabProps{
    mode: number;
    thirdBox: any;
    setThirdBox: any;
}

function ResourcesTab({ mode, thirdBox, setThirdBox }: ResourcesTabProps) {
    return (
        <Box 
            sx={{
                flexShrink: 1,
                flexGrow: 1,
                transition: 'all 0.3s ease',
                minWidth: '350px',
                maxWidth: '350px',
                backgroundColor: 'white',
                overflow: 'hidden',
                display: thirdBox.visible ? 'flex' : 'none',
                border: "1px solid #9d9e9e",
                borderRadius: 1
            }}
        >
            <Box
                sx={{ display: thirdBox.value === 2 ? 'flex' : 'none', width: '100%'}}
            >
                <NoteDictionary mode={mode} setThirdBox={setThirdBox}/>
            </Box>
        </Box>  
    );
}

export default memo(ResourcesTab);